<template>
    <div class="orderBuy" :class="{show: show}" ref="container">
        <div class="close_btn" @click='close'></div>
        <div style="height:100%;overflow:auto;" ref='scrollBox'>
            <div class="Personal_Information">
                <div class="title" v-show='!isTaiLi'>{{isCourse ? '请填写订单购买方相关信息' : '请填写购买协议甲方相关信息'}}：</div>
                <div class="form_Msg">
                    <div class="form_tit">姓名或机构名称</div>
                    <div class="form_input">
                        <input type="text" autocomplete="off" @focus="nameFocus" @input="nameInput" id="UserName" v-model="JudgeIsCompany.UserName"
                            ref="count" class="step2_infotext" v-bind:disabled="isedit && isEditUserName"><span>*</span>
                            <el-card class="down_pull" v-show="name_pull_down_show" ref="name_pull_down">
                                <i class='el-icon-loading' v-show="name_pull_down_loading"></i>
                                <ul v-for="(item, index) in name_pull_down_list" :key="item.nsrsbh">
                                    <li :class="{active: name_pull_down_index == index}" @click="nameSelect(item, index)">{{item.qymc}}</li>
                                </ul>
                                <a class="more" v-if="more_show" @click.stop="toMore">更多</a>
                            </el-card>
                        
                    </div>
                    <div class="form_span">发票以此为抬头开具，电子发票可在本网站首页-><a href="https://u.wenhua.com.cn/"
                            target="_blank">个人中心</a>下载</div>
                </div>
                <div class="form_Msg" v-if="JudgeIsCompany.longAccountType">
                    <div class="form_tit"></div>
                    <div class="form_input">
                        <input type="checkbox" name="" id="accountType" v-model="JudgeIsCompany.longIfcompany"><label for="accountType">如果是个人用户，请勾选此项</label>
                    </div>
                    <div class="form_span"></div>
                </div>
                <div class="form_Msg">
                    <div class="form_tit">手机号（会员号）</div>
                    <div class="form_input"><input type="text" id="Phone" v-model="JudgeIsCompany.Phone"
                            v-bind:disabled="isEditPhone || OrderDetails.productId == 129" class="step2_infotext"><span>*</span>
                    </div>
                    <div class="form_span">{{isTaiLi ? '' : '用于接收授权账号短信'}}</div>
                </div>
                <div class="form_Msg" v-show="(OrderDetails.isout && (JudgeIsCompany.ice == '1' || JudgeIsCompany.lme == '1')) || isLive || islmeJN">
                    <div class="form_tit">邮箱</div>
                    <div class="form_input"><input type="text" id="email" v-model="OrderDetails.email"
                            class="step2_infotext"><span>{{islmeJN ? '' : '*'}}</span></div>
                    <div class="form_span"></div>
                </div>
                <div class="form_Msg" v-show="isCompany">
                    <div class="form_tit">联系人姓名</div>
                    <div class="form_input"><input type="text" id="ContactName" v-model="JudgeIsCompany.ContactName"
                            class="step2_infotext"><span>*</span></div>
                    <div class="form_span"></div>
                </div>
                <!-- <div class="form_Msg">
                    <div class="form_tit">入住时间</div>
                    <div class="form_input">
                        <el-date-picker
                        v-model="checkDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format='yyyy-MM-dd'
                        style='width:95%;height:32px;padding-top:0;padding-bottom:0;' class='date-picker'>
                        </el-date-picker>
                        <span>*</span>
                    </div>
                    <div class="form_span"></div>
                </div> -->
                <div class="form_Msg">
                    <div class="form_tit">所在地</div>
                    <div class="form_input">
                        <select v-model="listQuery.provinceId" class="filter-item" @change="changeQueryProvince"
                            clearable>     <!-- v-bind:disabled="(isedit && countryEdit)" -->
                            
                            <option v-for="(item, index) in provinceShowList" :key="index" :value="item">{{ item }}</option>
                        </select>
                        <select v-model="listQuery.cityId" class="filter-item" @change="changeQueryCity" clearable
                             v-show="isCountry"> <!-- v-bind:disabled="isedit && provinceEdit" -->
                             
                            <option disabled="true">省份</option>
                            <option v-for="(item, index) in queryCityList" :key="index" :value="item.regioN_NAME">
                                {{ item.regioN_NAME }}</option>
                        </select>
                        <select v-model="listQuery.regionId" class="filter-item" clearable
                             v-show="isCountry"> <!-- v-bind:disabled="isedit && cityEdit" -->
                            <option disabled="true">城市</option>
                            <option v-for="(item, index) in queryRegionList" :key="index" :value="item.regioN_NAME">
                                {{ item.regioN_NAME }}</option>
                        </select>
                        <input type="text" placeholder="请填写城市" id="external_city" v-model="listQuery.external_city"
                            v-show="!isCountry" v-bind:disabled="isedit && externalEdit">
                        <span>*</span>
                    </div>
                    <div class="form_span"></div>
                </div>
                <div class="form_Msg" v-show="OrderDetails.isout">
                    <div class="form_tit">详细地址</div>
                    <div class="form_input"><input type="text" id="DetailAddr" v-model="JudgeIsCompany.DetailAddr"
                            class="step2_infotext" ><span>*</span></div> <!-- v-bind:disabled="isedit && isEditDetailAddr" -->
                    <div class="form_span"></div>
                </div>
                <div class="form_Msg" v-show="isCountry">
                    <div class="form_tit">身份证号</div>
                    <div class="form_input"><input type="text" id="idCard" v-model="JudgeIsCompany.idCard"
                            class="step2_infotext" v-bind:disabled="isedit && isEditIdCard && !isCompany"><span>*</span></div>
                    <div class="form_span"></div>
                </div>
                
                <div class="form_Msg" v-show="isCompany && !isCountry && !islmeJN">
                    <div class="form_tit">护照号</div>
                    <div class="form_input"><input type="text" id="contactpassport"
                            v-model="JudgeIsCompany.contactpassport" class="step2_infotext"
                            v-bind:disabled="isedit && isEditPassport"><span>*</span></div>
                    <div class="form_span"></div>
                </div>
                <div class="form_Msg" v-show="(!isCompany && !isCountry)||(isCompany && islmeJN && !isCountry)">
                    <div class="form_tit">证件号</div>
                    <div class="form_input">
                        <select id="isidcard" class="filter-item" v-bind:disabled="isedit && isEditPassport || islmeJN"
                            v-model="JudgeIsCompany.isidcard">
                            <option v-for="(item, index) in Card" :key="index" :value="item.id">{{ item.value }}
                            </option>
                        </select>
                        <input type="text" id="DetailUserId" v-model="JudgeIsCompany.DetailUserId"
                            class="step2_infotext" v-bind:disabled="isedit && isEditDetailUserId"><span>*</span></div>
                    <div class="form_span"></div>
                </div>
                <div class="form_Msg" v-show="isCompany">
                    <div class="form_tit">统一社会信用代码</div>
                    <div class="form_input"><input type="text" id="FaxNumber" v-bind:disabled="isCompany && name_pull_down_index >= 0" v-model="JudgeIsCompany.FaxNumber"
                            class="step2_infotext"><span>*</span></div>
                    <div class="form_span"></div>
                </div>
                <div class="form_Msg" v-if="BuySituation == '2' && OpentimeShow && !isPeiXun && !isCourse">
                    <!--只有新购7,8,9显示-->
                    <div class="form_tit">开通时间</div>


                    <div class="form_input">
                        <el-date-picker style='width:95%;' class='date-picker' v-model="chaneOpenTime" size='small'
                            type="date" :editable='false' :picker-options='pickerOption' :value-format='"yyyy-MM-dd"' :disabled="openTimeDisable"
                            placeholder="选择日期">
                        </el-date-picker>
                        <!-- <select id="addtime" v-model="chaneOpenTime" class="step2_infotext" v-bind:disabled="isedit && isEditSdate">
                            <option v-for="(item, index) in Opentime" :key="index" :value="item.date_id">{{ item.date_name }}</option>
                        </select> -->
                    </div>
                    <div class="form_span"></div>
                </div>
                <div>
                    <div class="form_Msg" v-show="isInvoice">
                        <div class="form_tit"></div>
                        <div class="form_input"><input type="checkbox" id="Invoicing" v-model="Invoicing"><label
                                for="Invoicing">需要增值税专用发票</label></div>
                        <div class="form_span"></div>
                    </div>
                    <div class="form_Msg" v-show="Invoicing">
                        <div class="form_tit">开票地址</div>
                        <div class="form_input"><input type="text" id="CompanyAddress"
                                v-model="JudgeIsCompany.CompanyAddress" class="step2_infotext"><span>*</span></div>
                        <div class="form_span">与营业执照上的地址一致</div>
                    </div>
                    <div class="form_Msg" v-show="Invoicing">
                        <div class="form_tit">开票电话</div>
                        <div class="form_input"><input type="text" id="CompanyTelnumber"
                                v-model="JudgeIsCompany.CompanyTelnumber" class="step2_infotext"><span>*</span></div>
                        <div class="form_span">公司座机号码</div>
                    </div>
                    <div class="form_Msg" v-show="Invoicing">
                        <div class="form_tit">开票开户行</div>
                        <div class="form_input"><input type="text" id="CompanyBank" v-model="JudgeIsCompany.CompanyBank"
                                class="step2_infotext"><span>*</span></div>
                        <div class="form_span">与开户许可证上的银行一致</div>
                    </div>
                    <div class="form_Msg" v-show="Invoicing">
                        <div class="form_tit">开票账号</div>
                        <div class="form_input"><input type="text" id="CompanyAccount"
                                v-model="JudgeIsCompany.CompanyAccount" class="step2_infotext"><span>*</span></div>
                        <div class="form_span">与开户许可证上的银行账号一致</div>
                    </div>
                    <div class="form_Msg" v-show="((Invoicing || JudgeIsCompany.AddrShow) && (!isTProduct || (isTProduct && paperContract)))  || isTaiLi">
                        <!-- isWH7_8_9_Newbuy -->
                        <div class="form_tit">邮寄地址</div>
                        <div class="form_input">
                            <div style="width:95%;display:inline-block;">
                                <select v-model="JudgeIsCompany.postaddr" class="filter-item" v-show="isCountry" clearable style="width:40%;margin-right:10px;">
                                    <option disabled="true">省份</option>
                                    <option v-for="(item, index) in queryCityList" :key="index" :value="item.regioN_NAME">
                                        {{ item.regioN_NAME }}</option>
                                </select>
                                <input type="text" id="InvoiceAddr" v-model="JudgeIsCompany.InvoiceAddr" class="step2_infotext"
                                    style='width:calc(60% - 10px);'>
                            </div>
                            <span v-show="InvoiceAddrRequire || isCourse || isTaiLi">*</span>
                        </div>
                        <div class="form_span">{{ invoiceTips }}</div>
                    </div>
                </div>
                <div v-show="isInvoice || hasHistory"> 
                    
                    <div class="form_Msg" v-if='!isTaiLi && Invoicing && isInvoice && !isPeiXun  || hasHistory'>
                        <div class="form_tit"></div>
                        <div class="form_input"><input type="checkbox" id='papercontract' v-model="paperContract" :disabled="hasHistory"><label
                                for='papercontract'>需要纸质版合同</label></div>
                        <div class="form_span"></div>
                    </div>
                    <div class="form_Msg" v-if='paperContract && Invoicing && isInvoice || hasHistory'>
                        <div class="form_tit"></div>
                        <div class="form_input">
                            <p>请选择收款银行：<radio-box inline @change='bankChange' :data='[{label: "招商银行", value: 8,default:true}]' /></p>
                            
                        </div>
                        <div class="form_span"></div>
                    </div>
                </div>
                <div class="Personal_Information">
                    <div class="form_Msg" v-show="seats.length > 0 || isLive">
                        <div class="form_tit">听课形式</div>
                        <div class="form_input">
                            <div class="select-sit" v-if="isLive">
                                线上听课
                            </div>
                            <template v-else>
                                <div class="select-sit" v-for="(sit, i) in seats" :key="i">
                                    现场选座  {{sit}}
                                </div>
                            </template>
                        </div>
                        <div class="form_span"></div>
                    </div>
                </div>
                <div class="form_Msg" v-show="isPeiXun && !isLive">
                    <div class="form_tit"></div>
                    <div class="form_input"><input type="checkbox" id="bookHotel" v-model="bookHotel"><label
                            for="bookHotel">需要代订住宿酒店</label></div>
                    <div class="form_span"></div>
                </div>
                <!-- <div class="form_Msg" v-show="isPeiXun && bookHotel">
                    <div class="form_tit">选择酒店</div>
                    <div class="form_input">
                        <select>
                            <option>请选择</option>
                            <option value="1">xxxxxxxxxxxx</option>
                        </select>
                    </div>
                    <div class="form_span"></div>
                </div> -->
                <div class="form_Msg" v-show="isPeiXun && bookHotel && !isLive">
                    <div class="form_tit">入住日期</div>
                    <div class="form_input">
                        <el-date-picker
                        v-model="checkDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format='yyyy-MM-dd'
                        :picker-options='checkDatePicker'
                        style="width:95%;height:32px;padding-top:0;padding-bottom:0;" class='date-picker'>
                        </el-date-picker>
                        <span>*</span>
                    </div>
                    <div class="form_span"></div>
                </div>
                
                <div class="form_Msg" v-show="isPeiXun && !isLive">
                    <div class="form_input">
                        <table class="tali_table" style="margin: 0 0 0 165px;" cellspacing='0' cellpadding='0' border='1'>
                            <tr>
                                <th>地区</th>
                                <th>酒店名称</th>
                                <th>标准</th>
                                <th>酒店地址</th>
                                <th>房间类型</th>
                                <th>协议价格</th>
                                <th>备注</th>
                                <th>培训地址</th>
                            </tr>
                            <tr>
                                <td>西直门</td>
                                <td>北京宝德饭店</td>
                                <td>四星</td>
                                <td>北京市西城区西直门外大街</td>
                                <td>标准间</td>
                                <td>480元/天</td>
                                <td>不含早餐</td>
                                <td>培训所在地</td>
                            </tr>
                        </table>
                        <p style="font-size:12px;color:rgb(212, 2, 1);margin-left:165px;margin-top:5px;">注：以报名人登记，到达酒店后直接到服务台可查询，自行付款办理入住及离开。</p>
                    </div>
                </div>
                <!-- <div class="form_Msg" v-show="isPeiXun && bookHotel">
                    <div class="form_tit"></div>
                    <div class="form_input">
                        <input type="radio" id='isBreakfast' name='hasBreakfast' v-model="isBreakfast">
                        <label for="isBreakfast">480元/天 不含早餐</label>
                        <br>
                        <input type="radio" id='noBreakfast' name='hasBreakfast' v-model="isBreakfast">
                        <label for="noBreakfast">580元/天 含早餐</label>
                    </div>
                    <div class="form_span"></div>
                </div> -->
                
            </div>
            <hr v-show="OrderDetails.contract != null">
            <!-- <h3 style='text-align: center;padding:20px 0;font-size:20px;' v-show="!JudgeIsCompany.AddrShow && !isTaiLi && !isPeiXun">
                购买服务协议
            </h3> -->
            <table class="tali_table" cellspacing='0' cellpadding='0' border='1' v-if="isTaiLi">
                <tr>
                    <th colspan="6">商品信息</th>
                </tr>
                <tr>
                    <td>购买商品</td>
                    <td>单价（元）</td>
                    <td>数量</td>
                    <td>金额（元）</td>
                    <td>税额（元）</td>
                    <td>价税合计（元）</td>
                </tr>
                <tr>
                    <td>2026年台历</td>
                    <td>{{OrderDetails.TotalPrice/OrderDetails.amount}}</td>
                    <td>{{OrderDetails.amount}}</td>
                    <td>{{(OrderDetails.TotalPrice - OrderDetails.TotalPrice*0.13/1.13).toFixed(2)}}</td>
                    <td>{{(OrderDetails.TotalPrice*0.13/1.13).toFixed(2)}}</td>
                    <td>{{OrderDetails.TotalPrice}}</td>
                </tr>
                <tr>
                    <td>台历运费</td>
                    <td>{{freight}}</td>
                    <td>1</td>
                    <td>{{(freight - freight*0.13/1.13).toFixed(2)}}</td>
                    <td>{{(freight*0.13/1.13).toFixed(2)}}</td>
                    <td>{{freight}}</td>
                </tr>
                <!-- <tr v-if="Invoicing">
                    <td>发票运费</td>
                    <td>{{invoice_freight}}</td>
                    <td>1</td>
                    <td>{{(invoice_freight - invoice_freight*0.13/1.13).toFixed(2)}}</td>
                    <td>{{(invoice_freight*0.13/1.13).toFixed(2)}}</td>
                    <td>{{invoice_freight}}</td>
                </tr> -->
                <tr>
                    <td colspan="3">价格总计</td>
                    <td>{{(totalPrice - totalPrice*0.13/1.13).toFixed(2)}}</td>
                    <td>{{(totalPrice*0.13/1.13).toFixed(2)}}</td>
                    <td>{{totalPrice}}</td>
                </tr>
            </table>
            <div class="Purchase_Contract" ref='contract' v-html="OrderDetails.contract"></div>
            
            <div class="agreeMent" v-show="initData.productId != '27' && initData.productId != '127'&& initData.productId != '132' && !isPeiXun"><input
                    type="checkbox" name="" id="agreement" v-model="ifagree"><label
                    for="agreement">{{isCourse ? '我已阅读并同意《模型编写视频教程》线上视频课订单的全部内容。' : txtCheck}}</label></div>
            <div class="TotalPrice">价格总计：<span>{{ totalPrice }}</span>元
                
            </div>
            <NormalButton class="submitForm" :theme='"red"' ref="subBtn" @click='submitForm'>
                {{!JudgeIsCompany.AddrShow && !isTaiLi && !isPeiXun ? '同意以上协议并去付款':'去付款'}}</NormalButton>
        </div>
    </div>
</template>

<script>
    import service from '../assets/js/service'
    import {
        Validator
    } from "../assets/js/address"
    import "@/assets/css/contract.css"
    import calendar from "@/assets/js/calendar.json"
    import invoice from "@/assets/js/invoice.js"
    import wh from "@/assets/js/wh.js"
    import cookie from 'js-cookie'
    //获取本月的天数
    function mGetDate() {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var d1 = new Date(year, month, 0);
        var d2 = new Date(year, month, 0);
        var d3 = new Date(year, month, 0);
        return d1.getDate() +d2.getDate()+d3.getDate();
    }
    const close_time_creater = (() => {
        const cache = new Set()
        let fn = (axios, date, type) => {
            cache.clear()
            const random = wh.randomId()
            cache.add(random)
            return new Promise(resolve => {
                axios({
                    url:`/api/Product/GetEndDate?sdate=${date}&type=${type}`,
                }).then((res) => {
                    if (cache.has(random)) {
                        cache.delete(random)
                        //数据处理
                        resolve(res)
                    }
                })
            })
            
        }
        return fn
    }) ()
    const throttle = (function (delay = 1000) {
        let lastCallTime = 0;
        let func = null, timer
        return function (...args) {
            const now = new Date().getTime();
            if (lastCallTime == 0) lastCallTime = now
            if (now - lastCallTime < delay) {
                lastCallTime = now
                clearTimeout(timer)
                timer = setTimeout(() => {
                    func(...args)
                    lastCallTime = 0
                    func = null
                    timer = null
                }, delay)
            }
            return new Promise(resolve => {
                func = resolve
            })
        };
    }) ()
    export default {
        name: "order",
        props: {
            show: {
                default: true,
                type: Boolean
            }
        },
        data() {
            let self = this
            return {
                emailTxt: '纸质类文件通过这个地址邮寄',
                isedit: true,
                OrderDetails: { //订单详细信息
                    isout: false,
                    ismajor: '',
                    isjg: '',
                    userCode: '',
                    email: '',
                    xzh: '',
                    TotalPrice: '', //价格总计
                    contract: '', //合同内容
                    amount: '',
                    payGateID: '',
                    dzh: '',
                    subids: '',
                    productId: '',
                    morderid: '',
                    isDanAuthorization: '',
                    hasHistory: false,
                    wh10Account: '',
                    isWh10TryAccount: false,
                    isWh5TransAccount: false,
                    wh5Account: '',
                    isWh5Autojg: false,
                    isOnly5C: false,
                    makeup:0
                },
                Card: [ //证件号品种
                    {
                        id: '1',
                        value: '护照号'
                    },
                    {
                        id: '2',
                        value: '身份证号'
                    }
                ],
                isCountry: true, //是否是中国大陆
                cityName: '', //城市名字
                isCompany: false, //姓名长度判断是否是个人
                Invoicing: false, //是否需要增值发票
                JudgeIsCompany: {
                    UserName: '', //姓名或机构名称
                    longAccountType: false,
                    longIfcompany: null,
                    Phone: '', //手机号码
                    idCard: '', //身份证号
                    FaxNumber: '', //统一社会信用代码
                    CompanyAddress: '', //开票地址
                    CompanyTelnumber: '', //开票电话
                    CompanyBank: '', //开票开户行
                    CompanyAccount: '', //开票账号
                    InvoiceAddr: '', //邮政地址
                    AddrShow: false,
                    DetailAddr: '', //详细地址
                    ContactName: '', //联系人姓名
                    DetailUserId: '', //证件号
                    isidcard: '1', //证件号品种id
                    contactpassport: '', //护照号
                    ice: '1',
                    postaddr: '省份'
                },
                provinceList: [], //所在地国家
                queryCityList: [], //所在地省份
                queryRegionList: [], //所在地城市
                listQuery: { //城市选择的信息
                    provinceId: "",
                    cityId: "省份",
                    regionId: '城市',
                    external_city: ''
                },
                Opentime: [], //开通时间
                OpentimeShow: false,
                chaneOpenTime: '', //选择开通时间
                ifagree: null, //是否同意条款
                BuySituation: '2', //购买形势  新购，加购，续费
                initData: {}, //初始化数据
                pickerOption: {
                    disabledDate: date => {
                        var today = (self.OrderDetails.chaneOpenTime ? new Date(self.OrderDetails.chaneOpenTime) : new Date()).getTime(),
                            curday = date.getTime()
                        var days = mGetDate()
                        if (curday < today - 3600 * 24 * 1000 || (curday - today > 3600 * 24 * 1000 * days))
                            return true
                        return false
                    }
                },
                freight: 0,
                invoice_freight: 0,
                paperContract: false, //是否需要纸质合同
                paperBank: 8, //纸质合同的所选银行
                seats: [],
                checkDate: '', //入住时间
                bookHotel: false, //是否订酒店
                checkDatePicker: {
                    // disabledDate (date) {
                    //     let time = new Date(date)
                    //     let year = time.getFullYear(),month = time.getMonth() + 1,day = time.getDate()
                    //     return !(year == 2021 && month == 10 && (day == 29 || day == 30 || day == 31))
                    // }
                },
                name_pull_down_show: false,
                name_pull_down_loading: true,
                name_pull_down_list: [],
                name_pull_down_index: -1,
                more_show: true,
                // txtCheck:'我已阅读《购买服务协议》，同意遵守所有约定。'
            }
        },
        computed: {
            wh: _ => wh,
            invoiceTips () {
                if (this.isCourse) return '用于寄送课程教材'
                else return this.emailTxt
            },
            addOpenTime: function () {
                var timeArr = [];
                var days = mGetDate()
                for (let i = 0; i < days; i++) {
                    let today = new Date();
                    today.setTime(today.getTime() + i * 24 * 60 * 60 * 1000);
                    let year = today.getFullYear();
                    let month = (today.getMonth() + 1).toString().padStart(2, '0');
                    let day = today.getDate().toString().padStart(2, '0');
                    let s3 = year + "-" + month + "-" + day;
                    let s4 = year + "-" + month + "-" + day;
                    timeArr.push({
                        date_id: s4,
                        date_name: s3
                    });
                }
                return timeArr;
            },
            isEditPhone () {
                return (this.initData.productId == '27' && this.isedit) || ((this.isWH10AndWH5 || this.isWH11) && this.initData.wh10Phone && this.initData.wh10Phone != '')
            },
            isEditDetailUserId() { //
                return this.initData.passport == null ? (this.initData.idCard != null && this.initData.idCard != '') : (
                    this.initData.passport != '');
            },
            isEditIdCard() {
                if (this.initData.accountType == '公司') {
                    return this.initData.contactIdCard != null && this.initData.contactIdCard != ''
                }
                return this.initData.idCard != null && this.initData.idCard != ''
            },
            isEditUserName() {
                return this.initData.userName != null && this.initData.userName != ''
            },
            isEditContactName() {
                return this.initData.contactName != null && this.initData.contactName != ''
            },
            isEditDetailAddr() {
                return this.initData.detailAddr != null && this.initData.detailAddr != ''
            },
            isEditPassport() {
                return (this.initData.passport != null && this.initData.passport != '')
            },
            islmeJN () {//是授权选择了lme境内查看
                return this.initData.islmgJn == 1
            },
            isEditFaxNumber() {
                return this.initData.faxNumber != null && this.initData.faxNumber != '' && this.isedit
            },
            isEditSdate() {
                return this.initData.sdate != null && this.initData.sdate != ''
            },
            countryEdit() {
                return this.initData.country != null && this.initData.country != ''
            },
            externalEdit() {
                return this.initData.city != null && this.initData.city != ''
            },
            provinceEdit() {
                return this.initData.orderUserProv != null && this.initData.orderUserProv != ''
            },
            openTimeDisable () {
                return (this.OrderDetails.isWh5Autojg && this.OrderDetails.isOnly5C) || (this.OrderDetails.isWh10AutoJg && this.isWH10)
            },
            cityEdit() {
                return this.initData.city != null && this.initData.city != ''
            },
            isTaiLi() {
                return this.initData.productId == 127 || this.initData.productId == 132
            },
            isPeiXun() {
                return  [46,107].includes(this.initData.productId)
            },
            isWH7 () {
                return  [76,123].includes(this.initData.productId)
            },
            isWT8() {
                return  [1,122].includes(this.initData.productId)
            },
            isWT9() {
                return  [124].includes(this.initData.productId)
            },
            isTaiLiNeed() {
                return this.OrderDetails.TotalPrice >= 1000 && this.isTaiLi
            },
            totalPrice() {
                let price = Number(this.OrderDetails.TotalPrice)
                if (this.isTaiLi) {
                    price += Number(this.freight)
                    // if (this.Invoicing) {
                    //     price += Number(this.invoice_freight)
                    // }
                }
                return price
            },
            isInvoice() {
                if (this.isTaiLi) {
                    return this.isCompany
                    // 运营部 - 3 - 柏慧（客户运营）(baih) 08:58:40
                    // 这里应该能勾选要专票
                    // 运营部 - 3 - 柏慧（客户运营）(baih) 08:59:14
                    // 就是这个，原来只有1000以上的才能看到
                    // return this.OrderDetails.TotalPrice >= 1000 && this.isCompany
                } else {
                    return this.isCompany
                }
            },
            isLive () {//是否是培训班的线上直播
                return this.initData.islive
            },
            isWH10 () {
                return [110,125, 138].includes(this.OrderDetails.productId)
            },
            isWH10AndWH5 () {
                return [110,125,126,128, 129, 138].includes(this.OrderDetails.productId)
            },
            isWH11 () {
                return [131].includes(this.OrderDetails.productId)
            },
            isCourse () {
                return [136].includes(this.OrderDetails.productId)
            },
            hasHistory () {
                return this.OrderDetails.hasHistory
                
            },
            isNewBuy () {
                return this.BuySituation == 2
            },
            isWH7_8_9_Newbuy () {
                if (this.BuySituation == 2) {
                    if ([76, 123, 1, 122, 124].includes(this.OrderDetails.productId) && this.$store.state.newbuy.interface && !this.$store.state.newbuy.interface.data.isMonth && !this.$store.state.newbuy.interface.data.IsQuarter) return true
                    else if ([124].includes(this.OrderDetails.productId)  && this.$store.state.newbuy.interface && this.$store.state.newbuy.interface.data.IsQuarter) return true
                    else return false
                } else return false
            },
            InvoiceAddrRequire () {//邮寄地址为必填
                //如果勾选了需要发票，那肯定需要填邮寄地址
                //此外，根据id判断，设置了某些id的产品固定需要填写邮寄地址
                const id_restrain = this.OrderDetails.productId == 27
                return id_restrain || (this.Invoicing || this.JudgeIsCompany.AddrShow)
            },
            isTProduct () {
                return this.initData.productId == '1' || this.initData.productId == '124' ||  this.initData.productId == '138'
            },
            isMonth () {
                return this.OrderDetails.isMonth
            },
            IsQuarter () {
                return this.OrderDetails && this.OrderDetails.IsQuarter
            },
            txtCheck(){
                // wt8 9 续费的时候显示补充协议 勾选文案需要修改
                // 会返回 makeup 这个字段  0 标识没有附加附件  1 标识有
                if(this.OrderDetails.makeup == 1){
                    return '我已阅读《购买服务协议》及其补充协议，同意遵守所有约定。'
                }else{
                    return '我已阅读《购买服务协议》，同意遵守所有约定。'
                }
            },
            provinceShowList () {
                if (this.initData.islmgJn == 1) return ['中国大陆', '中国香港']
                return this.provinceList
            }

        },
        inject: ['orderShow', 'popOverShow', 'appOverFlow','clearAddBuyValidState', 'clearRenewBuyValidState'],
        created() {
            this.Opentime = this.addOpenTime;
            //初始化
            this.chaneOpenTime = this.Opentime[0]['date_id'];
            document.addEventListener('click', e => {
                if (e.target != this.$refs.count) {
                    this.name_pull_down_show = false
                }
            })
        },
        methods: {
            nameInput (val) {
                this.$nextTick(() => {
                    if (!this.isCompany) {
                        this.name_pull_down_show = false
                    }
                })
                throttle(val.target.value).then(value => {
                    if (this.isCompany) {
                        this.name_pull_down_show = true
                        this.name_pull_down_loading = true
                        this.name_pull_down_list = []
                        this.name_pull_down_index = -1
                        this.$axios({
                            url: '/api/Order/GetPassPortByPhone?gsname=' + value + '&isgd=false',
                            methods: 'get'
                        }).then(res => {
                            this.name_pull_down_loading = false
                            if (res.data.status) {
                                this.name_pull_down_list = res.data.data
                            } else {
                                
                                this.name_pull_down_show = false
                            }
                        })
                    }
                })
            },
            toMore () {
                this.name_pull_down_loading = true
                this.$axios({
                    url: '/api/Order/GetPassPortByPhone?gsname=' + this.JudgeIsCompany.UserName + '&isgd=true',
                    methods: 'get'
                }).then(res => {
                    this.name_pull_down_loading = false
                    this.more_show = false
                    if (res.data.status) {
                        this.name_pull_down_list.push(...res.data.gddata)
                    }
                })
            },
            nameFocus () {
                if(this.isCompany) {this.name_pull_down_show = true}
            },
            nameSelect (item, index) {
                console.log(item)
                this.name_pull_down_index = index
                this.name_pull_down_show = false
                this.$set(this.JudgeIsCompany, 'UserName', item.qymc)
                this.$set(this.JudgeIsCompany, 'FaxNumber', item.nsrsbh)

            },
            //数据初始化
            DataIinitialization(data) {

                //如果是培训班产品，获取浏览器缓存的选座状态
                if ([46,107].indexOf(data.data.productId) >= 0) {
                    this.seats = data.data.seatDto.seat == '' ? [] : data.data.seatDto.seat.split(',')
                } else {
                    this.seats = []
                }
                this.isCountry = true //重置状态
                this.initData = data.data
                this.paperContract = false
                this.ifagree = false;
                this.Invoicing = false;
                this.chaneOpenTime = this.Opentime[0]['date_id'];
                this.JudgeIsCompany.CompanyAddress = ''
                this.JudgeIsCompany.CompanyTelnumber = ''
                this.JudgeIsCompany.CompanyBank = ''
                this.JudgeIsCompany.CompanyAccount = ''
                this.JudgeIsCompany.InvoiceAddr = ''
                this.JudgeIsCompany.ice = data.data.ice
                this.JudgeIsCompany.lme = data.data.lme
                if (data.data.productId == '27') {
                    this.isedit = !data.data.isEdit && this.$store.state.otherOrderId != '' ? true : false;
                } else if (data.data.identity == 2) {
                    this.isedit = false
                } else {
                    this.isedit = data.data.isCme && !data.data.isEdit ? true : false;
                }
                if (this.isTaiLi) {
                    this.$set(this.listQuery, 'cityId', '省份')
                    this.freight = 0
                    this.invoice_freight = 0
                }
                this.OrderDetails.isout = data.data.isCme;
                this.BuySituation = data.data.identity;
                this.isCompany = data.data.accountType == "公司" ? true : false;

                this.OrderDetails.TotalPrice = data.data.price;
                this.OrderDetails.contract = data.data.contract;
                this.OrderDetails.ismajor = data.data.ismajor;
                this.OrderDetails.isjg = data.data.isjg;
                this.chaneOpenTime == null ? '' : data.data.sdate;
                this.OrderDetails.chaneOpenTime == null ? '' : data.data.sdate;
                this.OrderDetails.userCode = data.data.userCode;
                this.OrderDetails.xzh = data.data.xzh;
                this.OrderDetails.email = data.data.email;
                this.OrderDetails.amount = data.data.amount;
                this.OrderDetails.payGateID = data.data.payGateID;
                this.OrderDetails.dzh = data.data.dzh;
                this.OrderDetails.subids = data.data.subids;
                this.OrderDetails.productId = data.data.productId;
                this.OrderDetails.morderid = data.data.morderid;
                this.OrderDetails.isDanAuthorization = data.data.isDanAuthorization;
                this.OrderDetails.makeup = data.data.makeup;
                this.$set(this.OrderDetails, 'isMonth', data.data.isMonth)
                this.$set(this.OrderDetails, 'IsQuarter', data.data.IsQuarter)
                this.OrderDetails.hasHistory = data.data.hasHistory;
                if (this.OrderDetails.hasHistory) {
                    //如果包含历史数据API授权的话，要默认勾选需要纸质合同 2022-6-8历史数据API需求
                    this.paperContract = true
                }

                this.emailTxt = data.data.productId == 80 || data.data.productId == 44 || data.data.productId == 18 ||
                    data.data.productId == 27 ? '如有实物发送，将通过此地址邮寄' : '纸质类文件通过这个地址邮寄'
                this.JudgeIsCompany.AddrShow = data.data.productId == 44 || data.data.productId == 18 || data.data
                    .productId == 27 ? true : false
                this.OpentimeShow = data.data.productId == 44 || data.data.productId == 18 || data.data.productId ==
                    27 || data.data.productId == 127 || data.data.productId == 132? false : true


                this.JudgeIsCompany.UserName = data.data.userName == null ? '' : data.data.userName.replace(new RegExp('^\\&nbsp;+|\\&nbsp;+$', 'g'), '');
                if (data.data.accountType != "公司") {
                    this.JudgeIsCompany.idCard = data.data.idCard == null ? '' : data.data.idCard;
                } else {
                    this.JudgeIsCompany.idCard = data.data.contactIdCard == null ? '' : data.data.contactIdCard;
                }
                this.JudgeIsCompany.contactpassport = data.data.passport == null ? '' : data.data.passport;
                this.JudgeIsCompany.FaxNumber = data.data.faxNumber == null ? '' : data.data.faxNumber;
                this.JudgeIsCompany.Phone = data.data.phone == null ? '' : data.data.phone;
                this.JudgeIsCompany.ContactName = data.data.contactName == null ? '' : data.data.contactName;

                if ([110,125,126,128,129, 131, 138].includes(data.data.productId)) { //如果是wh10的产品，取出wh10的帐号密码留作后面用
                    data.data.wh10Phone && (this.JudgeIsCompany.Phone = data.data.wh10Phone)
                    data.data.wh10Account && (this.OrderDetails.wh10Account = data.data.wh10Account)
                    data.data.isWh10TryAccount && (this.OrderDetails.isWh10TryAccount = data.data.isWh10TryAccount)
                    data.data.isWh10TryAccountDate && (this.chaneOpenTime = data.data.isWh10TryAccountDate)
                    data.data.isWh10AutoJg && (this.OrderDetails.isWh10AutoJg = data.data.isWh10AutoJg)
                    data.data.isWh5TransAccount && (this.OrderDetails.isWh5TransAccount = data.data.isWh5TransAccount)
                    data.data.wh5OpenDate && (this.chaneOpenTime = data.data.wh5OpenDate)
                    data.data.wh5Account && (this.OrderDetails.wh5Account = data.data.wh5Account)
                    data.data.wh5Phone && (this.JudgeIsCompany.Phone = data.data.wh5Phone)
                    data.data.isWh5Autojg && (this.OrderDetails.isWh5Autojg = data.data.isWh5Autojg)
                    data.data.isOnly5C && (this.OrderDetails.isOnly5C = true)

                }
                
                //初始化城市
                let orderSubmitData = this.$store.state.Order.submitData
                let _city = data.data.city ? data.data.city : (orderSubmitData?.regionId ? orderSubmitData.regionId : null)
                let _prov = data.data.orderUserProv ? data.data.orderUserProv : (orderSubmitData?.cityId ? orderSubmitData.cityId : null)
                this.getProvince(_prov, _city).then(() => {
                    this.listQuery.provinceId = (data.data.country == null || data.data.country == '') ? (orderSubmitData?.provinceId ? orderSubmitData.provinceId :'中国大陆') : data.data.country;
                    this.isCountry = this.listQuery.provinceId == '中国大陆' || this.listQuery.provinceId ==
                        '' ? true : false;
                    this.listQuery.external_city = this.listQuery.provinceId == '中国大陆' ? '' : data.data
                        .city;

                    this.JudgeIsCompany.DetailAddr = data.data.detailAddr == null ? '' : this.formatAddr(data.data
                        .detailAddr.replace(/&nbsp;/g,'/s'));
                    if (this.listQuery.provinceId != '中国大陆') {
                        this.JudgeIsCompany.DetailUserId = this.JudgeIsCompany.contactpassport == '' ? data
                            .data.idCard : this.JudgeIsCompany.contactpassport;
                        this.JudgeIsCompany.isidcard = this.JudgeIsCompany.contactpassport == '' ? 2 : 1;
                    }
                });

                if (this.isTaiLi || this.isLive) {
                    this.queryCityList = calendar.area.map(v=>({
                        ...v,
                        regioN_NAME: v.prov
                    }))
                }
                this.$nextTick(() => {
                    if (data.data.contract) {
                        this.firstAdd();
                        this.c_click();
                    }
                    this.$refs.scrollBox.scrollTop = 0;
                })
            },

            c_click() {
                var e_title = document.getElementsByClassName('e_title')
                for (var i = 0; i < e_title.length; i++) {
                    e_title[i].index = i;
                    document.getElementsByClassName('c_all_content')[i].style.display = 'none';
                    e_title[i].onclick = function () {
                        var obj = document.getElementsByClassName('c_all_content')[this.index];
                        if (obj.className.indexOf('g_show') > -1) {
                            obj.classList.remove("g_show");
                        } else {
                            obj.classList.add("g_show");
                        }
                    }
                }

                var c_sh = document.getElementsByClassName('c_sh')
                for (var i = 0; i < c_sh.length; i++) {
                    c_sh[i].index = i;
                    c_sh[i].onclick = function () {
                        var _this = this;
                        var obj = document.getElementsByClassName('c_sh')[_this.index].parentNode.nextSibling
                            .nextSibling;
                        showPand(obj);
                        if (this.innerHTML == '收起') {
                            this.innerHTML = '展开'
                        } else {
                            this.innerHTML = '收起'
                        }
                    }
                }

                var c_href = document.getElementsByClassName('c_href')[0]
                c_href.onclick = function () {
                    var show = document.getElementsByClassName('c_all_content')[0];
                    showPand(show);
                }

                function showPand(obj) {
                    if (obj.className.indexOf('g_none') > -1) {
                        obj.classList.remove("g_none");
                    } else {
                        obj.classList.add("g_none");
                    }
                }
            },

            firstAdd() {
                let num, numname;
                if (this.isCompany) {
                    num = this.JudgeIsCompany.FaxNumber;
                    numname = '';
                } else {
                    if (this.isCountry) {
                        num = this.JudgeIsCompany.idCard;
                        numname = '身份证号';
                    } else {
                        num = this.JudgeIsCompany.DetailUserId;
                        numname = this.JudgeIsCompany.isidcard == 1 ? '护照号' : '身份证号';
                    }
                }
                this.addInput(this.JudgeIsCompany.UserName, numname, num, this.JudgeIsCompany.Phone, this.JudgeIsCompany
                    .ContactName, this.isCompany);

                let unit = this.$refs.contract.getElementsByClassName('unit')[0]
                if (unit) {
                    if (this.IsQuarter) {
                        unit.innerHTML = '季'
                    } else if (this.isMonth) {
                        unit.innerHTML = '月'
                    } else {
                        unit.innerHTML = '年'
                    }
                }
                this.triggerAttachment_4()
            },
            triggerAttachment_4 () {
                //2026-1-1就可以删除此处功能
                setTimeout(() => {
                    let newshang = this.$refs.contract.getElementsByClassName('newshang')
                    let e_newshang = this.$refs.contract.getElementsByClassName('e_newshang')
                    let e_newshangbox = this.$refs.contract.getElementsByClassName('e_newshangbox')
                    let e_title = this.$refs.contract.getElementsByClassName('e_title')
                    const accessory4 = document.querySelectorAll('[data-to="#accessory4"]');
                    console.log(accessory4)
                    function isAfter2025 (inputDate) {
                        // 1. 处理输入，转换为 Date 对象
                        let targetDate;
                        if (inputDate instanceof Date) {
                            targetDate = inputDate;
                        } else if (typeof inputDate === 'string' || typeof inputDate === 'number') {
                            targetDate = new Date(inputDate);
                        } else {
                            console.error('输入格式错误！支持：YYYY-MM-DD 字符串、时间戳、Date 对象');
                            return null;
                        }

                        // 2. 校验 Date 对象是否有效（避免 Invalid Date）
                        if (isNaN(targetDate.getTime())) {
                            console.error('输入日期无效！请检查格式');
                            return null;
                        }

                        // 3. 定义 2025 年的截止时间：2026-01-01 00:00:00（毫秒级时间戳）
                        const endOf2026 = new Date(2026, 0, 1).getTime(); // 月份从 0 开始，0 = 1 月

                        // 4. 比较目标日期与截止时间
                        return targetDate.getTime() > endOf2026;
                    }
                    
                    // 工具函数：获取元素去空格后的纯文本
                    function getPureText(element) {
                        // innerText 优先（更贴近视觉呈现的文本），兼容 textContent
                        const text = element.innerText || element.textContent;
                        // 去除所有空白字符（空格、换行、制表符等），避免格式干扰
                        return text.replace(/\s+/g, '');
                    }

                    // 递归遍历所有元素，筛选匹配项
                    function findElementsByExactText(target) {
                        const result = [];
                        const allElements = document.getElementsByTagName('*'); // 获取所有元素

                        Array.from(allElements).forEach(element => {
                            const pureText = getPureText(element);
                            if (pureText === target.replace(/\s+/g, '')) { // 目标文本也去空格，确保匹配
                            result.push(element);
                            }
                        });

                        return result;
                    }
                    if (!isAfter2025(this.chaneOpenTime)) {
                        for (let i = 0; i < newshang.length; i++) {
                            newshang[i].style.display = 'none'
                        }
                        for (let i = 0; i < e_newshang.length; i++) {
                            e_newshang[i].style.display = 'none'
                        }
                        for (let i = 0; i < e_newshangbox.length; i++) {
                            e_newshangbox[i].style.display = 'none'
                        }
                        
                        if (e_title.length == 5) {
                            e_title[4].innerText = '[附件四]'
                        }
                        const targetText = "本协议中包含5个附件，是本协议不可分割内容，其中约定之内容与本协议有同等法律效力。";
                        // 执行匹配，获取结果
                        const matchedElements = findElementsByExactText(targetText);
                        matchedElements[0] && (matchedElements[0].innerText = "本协议中包含4个附件，是本协议不可分割内容，其中约定之内容与本协议有同等法律效力。")
                        accessory4[2].innerText = '[附件四]'
                    } else {
                        for (let i = 0; i < newshang.length; i++) {
                            newshang[i].style.display = 'block'
                        }
                        for (let i = 0; i < e_newshang.length; i++) {
                            e_newshang[i].style.display = 'block'
                        }
                        if (e_title.length == 5) {
                            e_title[4].innerText = '[附件五]'
                        }
                        const targetText = "本协议中包含4个附件，是本协议不可分割内容，其中约定之内容与本协议有同等法律效力。";
                        // 执行匹配，获取结果
                        const matchedElements = findElementsByExactText(targetText);
                        matchedElements[0] && (matchedElements[0].innerText = "本协议中包含5个附件，是本协议不可分割内容，其中约定之内容与本协议有同等法律效力。")
                        accessory4[2] && (accessory4[2].innerText = '[附件五]')
                    }
                })
                
            },
            addInput(name, numName, number, phone, person, flag) {
                let e_jia = document.getElementsByClassName('e_jia')[0];
                let fj_subscriber = document.getElementById('_fj_subscriber')
                let history_e_jia = document.getElementsByClassName('e_jia')[1];
                if (!e_jia) {
                    return;
                }
                if (fj_subscriber) {
                    fj_subscriber.innerHTML = name
                }
                if (flag) {
                    e_jia.innerHTML = name + ' (统一社会信用代码: ' + number + ' / 联系人姓名: ' + person + ' / 手机号（会员号）: ' + phone + ')'
                } else {
                    e_jia.innerHTML = name + ' (' + numName + ': ' + number + ' / 手机号（会员号）: ' + phone + ')'
                }

                if (history_e_jia && this.hasHistory) {
                    history_e_jia.innerHTML = e_jia.innerHTML
                }
                // 由于源代码中出现了('e_jia')[1]的判断 不知道是做什么用的 该修改着急 所以新起一个class 按照新的找
                let e_jiabu = document.getElementsByClassName('e_jiabu')[0];
                let history_e_jiabu = document.getElementsByClassName('e_jiabu')[1];
                if (!e_jiabu) {
                    return;
                }
                if (flag) {
                    e_jiabu.innerHTML = name + ' (统一社会信用代码: ' + number + ' / 联系人姓名: ' + person + ' / 手机号（会员号）: ' + phone + ')'
                } else {
                    e_jiabu.innerHTML = name + ' (' + numName + ': ' + number + ' / 手机号（会员号）: ' + phone + ')'
                }
                if (history_e_jiabu && this.hasHistory) {
                    history_e_jiabu.innerHTML = e_jiabu.innerHTML
                }
            },

            //获取城市信息
            getSystemRegions(params) {
                return this.$axios({
                    url: '/api/Order/GetProv?' + params,
                    methods: 'get'
                });
            },

            getProvince(citys, region) {
                return new Promise((resolve, reject) => {
                    this.getSystemRegions('type=0').then(response => {
                        this.provinceList = response.data;
                        this.listQuery.provinceId = this.listQuery.provinceId == '' ? response.data[0] :
                            this.listQuery.provinceId;

                    });
                    if (!this.isCountry) {
                        return;
                    }
                    this.getSystemRegions('type=1').then(response => {
                        this.queryCityList = response.data;
                        this.listQuery.cityId = citys == null || citys == '' ? "省份" : citys;
                        if (this.listQuery.cityId == '省份') {
                            this.queryRegionList = [];
                            this.listQuery.regionId = "城市";
                            return;
                        }
                        this.getSystemRegions('type=2&id=' + this.filterData(this.listQuery.cityId)
                            .regioN_ID).then(res => {
                            this.queryRegionList = res.data;
                            this.listQuery.regionId = region == null ? "城市" : region;
                        });
                    });
                    resolve();
                })
            },

            changeQueryProvince() {
                this.isCountry = this.listQuery.provinceId == '中国大陆' ? true : false;
                if (this.isCountry) {
                    this.JudgeIsCompany.DetailUserId = ''
                } else {
                    this.JudgeIsCompany.idCard = ''
                }
                // this.listQuery.cityId = '';
                // this.listQuery.regionId = '';
                // this.queryRegionList = [];
                // this.getSystemRegions('type=1').then(response => {
                //     this.queryCityList = response.data;
                //     this.listQuery.cityId = response.data[0].regioN_NAME;
                // });
            },

            changeQueryCity() {
                this.listQuery.regionId = '城市';
                if (this.listQuery.cityId != "省份" && this.listQuery.cityId != "") {
                    this.getSystemRegions('type=2&id=' + this.filterData(this.listQuery.cityId).regioN_ID).then(
                        response => {
                            this.queryRegionList = response.data;
                        });
                }
            },

            filterData(getId) {
                let filtData = this.queryCityList.find(ele => ele.regioN_NAME === getId);
                return filtData;
            },

            validateTextLength(value) {
                // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
                let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
                let mat = value.match(cnReg);
                let length;
                if (mat) {
                    length = mat.length + (value.length - mat.length) * 0.5;
                    return length;
                } else {
                    return value.length * 0.5;
                }
            },

            async submitForm(finish,load) {
                
                
                let self = this
                if (this.JudgeIsCompany.ice == "1" || this.JudgeIsCompany.lme == "1") {
                    const validat = new Validator();
                    validat.check(this.OrderDetails.email, [{
                        strategy: 'isEmpty',
                        errMsg: '请填写您的邮箱'
                    }]);

                    let errMsg = validat.checkResult();
                    if (errMsg) {
                        this.$market.orderAlert({
                            content: errMsg,
                            confirmCall() {
                                self.$refs.scrollBox.scrollTop = 0
                            }
                        });
                        finish()
                        return;
                    }
                }
                // const validat = new Validator();

                // validat.check(this.JudgeIsCompany.UserName, [{strategy: 'isEmpty', errMsg: '姓名不能为空'}]);
                // validat.check(this.JudgeIsCompany.Phone, [{strategy: 'isEmpty', errMsg: '手机号码不能为空'}]);
                if (this.JudgeIsCompany.UserName == '') {
                    this.$market.orderAlert({
                        content: '姓名或机构名称为必填项'
                    });
                    finish()
                    return
                }
                if (/^\d+$/g.test(this.JudgeIsCompany.UserName)) {
                    this.$market.orderAlert({
                        content: '姓名或机构名称不能为纯数字'
                    });
                    finish()
                    return;
                }
                if ((/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/).test(this.JudgeIsCompany.UserName) && this.JudgeIsCompany.UserName != "") {
                    this.$market.orderAlert({
                        content: '请勿填写不正确的姓名或者机构名称'
                    });
                    finish()
                    return;
                }
                if (this.JudgeIsCompany.Phone == '') {
                    this.$market.orderAlert({
                        content: '手机号为必填项'
                    });
                    finish()
                    return;
                }
                if (!(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/).test(this.OrderDetails.email) && (this.JudgeIsCompany.ice == "1" || this.JudgeIsCompany.lme == "1")) {
                    this.$market.orderAlert({
                        content: '请填写正确格式的邮箱'
                    });
                    finish()
                    return;
                }
                if (!(/^[(\u4e00-\u9fa5)|(a-zA-Z)|(\s)]+$/).test(this.JudgeIsCompany.ContactName) && this.JudgeIsCompany.ContactName != "") {
                    this.$market.orderAlert({
                        content: '请勿填写不正确的联系人姓名'
                    });
                    finish()
                    return;
                }
                if (!(/^[1][0-9]{10}$/.test(this.JudgeIsCompany.Phone)) && (this.listQuery.provinceId == '中国大陆' || this.listQuery.provinceId == '')) {
                    this.$market.orderAlert({
                        content: '手机号码格式不正确'
                    });
                    finish()
                    return;
                }
                
                if (!(/^\d+$/.test(this.JudgeIsCompany.Phone)) && (this.listQuery.provinceId != '中国大陆' || this.listQuery.provinceId == '')) {
                    this.$market.orderAlert({
                        content: '手机号码格式不正确'
                    });
                    finish()
                    return;
                }
                if (this.JudgeIsCompany.FaxNumber.replace(/\s/g, "") == '' && this.isCompany) {
                    this.$market.orderAlert({
                        content: '请填写社会统一信用代码'
                    });
                    finish()
                    return;
                }
                if ((!/^([0-9A-Z]{18}|[0-9A-Z]{15})+$/.test(this.JudgeIsCompany.FaxNumber)) && this.isCompany && this.JudgeIsCompany.FaxNumber.replace(/\s/g, "") != '') {
                    this.$market.orderAlert({
                        content: '社会统一信用代码格式不正确'
                    });
                    finish()
                    return;
                }
                if (!this.ifagree && !(this.OrderDetails.productId == 44 || this.OrderDetails.productId == 18 || this
                        .OrderDetails.productId == 27 || this.OrderDetails.productId == 127 || this.OrderDetails.productId == 132 || [46,107].includes(this.OrderDetails.productId))) {
                    this.$market.orderAlert({
                        content: this.isCourse ? '请勾选“我已阅读并同意《模型编写视频教程》线上视频课购买订单”' : '请勾选“我已阅读《购买服务协议》，同意遵守所有约定”'
                    });
                    finish()
                    return;
                }
                if (this.listQuery.cityId == '省份' && this.isTaiLi) {
                    this.$market.orderAlert({
                        content: '请选择省份'
                    });
                    finish()
                    return;
                }
                if (this.listQuery.regionId == '城市' && this.isTaiLi) {
                    this.$market.orderAlert({
                        content: '请选择城市'
                    });
                    finish()
                    return;
                }
                if (this.JudgeIsCompany.idCard == '' && this.isTaiLi) {
                    this.$market.orderAlert({
                        content: '请填写身份证号'
                    });
                    finish()
                    return;
                }
                if (this.bookHotel && this.isPeiXun && (this.checkDate == '' || this.checkDate == null)) {
                    this.$market.orderAlert({
                        content: '请填写入住酒店的日期'
                    });
                    finish()
                    return;
                }
                if (this.JudgeIsCompany.postaddr == '省份' && this.isTaiLi) {
                    this.$market.orderAlert({
                        content: '请填写邮寄地址省份'
                    });
                    finish()
                    return;
                }
                if (this.JudgeIsCompany.InvoiceAddr == '' && this.isTaiLi) {
                    this.$market.orderAlert({
                        content: '请填写邮寄地址'
                    });
                    finish()
                    return;
                }

                //台历的提示，快递停运提示
                // let taili_tip = await new Promise(resolve => {
                //     if (this.isTaiLi) {
                //         finish()
                //         this.$market.orderAlert({
                //             content: '因快递停运，您的订单将在1月30日快递恢复后发货。',
                //             btnTxt: '我知道了',
                //             closeBtn: true,
                //             confirmCall() {
                //                 resolve(true)
                //             }
                //         });
                //     } else {
                //         resolve(true)
                //     }
                // })
                // if (!taili_tip) return
                load()

                this.listQuery.regionId = this.listQuery.regionId == "城市" ? "" : this.listQuery.regionId
                
                if (this.$route.query.orderid && this.OrderDetails.productId == '27') {
                    this.OrderDetails.morderid = this.$route.query.orderid
                }

                let data = {
                    isCme: this.OrderDetails.isout,
                    userCode: this.OrderDetails.userCode,
                    xzh: this.OrderDetails.xzh,
                    identityType: this.BuySituation,
                    username: this.JudgeIsCompany.UserName,
                    ismajor: this.OrderDetails.ismajor,
                    isjg: this.OrderDetails.isjg,
                    sdate: this.chaneOpenTime,
                    phone: this.JudgeIsCompany.Phone,
                    prov: this.listQuery.cityId == "省份" ? "" : this.listQuery.cityId,
                    city: this.listQuery.provinceId == "中国大陆" ? this.listQuery.regionId : this.listQuery
                        .external_city,
                    detailaddr: this.JudgeIsCompany.DetailAddr,
                    idcard: (!this.isCompany && !this.isCountry && this.JudgeIsCompany.isidcard == "2")||(this.isCompany && !this.isCountry && this.islmeJN) ? this
                        .JudgeIsCompany.DetailUserId : this.JudgeIsCompany.idCard,
                    // idcard: this.isCompany ? this.JudgeIsCompany.FaxNumber : (this.isout ? this.JudgeIsCompany.DetailUserId : this.JudgeIsCompany.idCard),
                    isidcard: this.isCompany ? 0 : (this.isout ? this.JudgeIsCompany.isidcard : 1),
                    faxNumber: this.JudgeIsCompany.FaxNumber,
                    time: "",
                    email: this.OrderDetails.email,
                    country: this.listQuery.provinceId,
                    isYourself: "是",
                    contactname: this.JudgeIsCompany.ContactName,
                    contactIdCard: this.JudgeIsCompany.idCard,
                    contactPassport: !this.isCompany && !this.isCountry && this.JudgeIsCompany.isidcard == "1" ?
                        this.JudgeIsCompany.DetailUserId : this.JudgeIsCompany.contactpassport,
                    invoicetype: this.Invoicing ? 1 : 0,
                    CompanyAddress: this.JudgeIsCompany.CompanyAddress,
                    CompanyTelnumber: this.JudgeIsCompany.CompanyTelnumber,
                    CompanyBank: this.JudgeIsCompany.CompanyBank,
                    CompanyAccount: this.JudgeIsCompany.CompanyAccount,
                    InvoiceAddr: this.JudgeIsCompany.InvoiceAddr,
                    pid: this.OrderDetails.productId,
                    subids: this.OrderDetails.subids,
                    iscontract: this.paperContract ? 1: 0,
                    banks: this.paperBank,
                    accountType: this.isCompany ? "公司" : "个人",
                    IsWh9Old: this.OrderDetails.hasHistory,
                    sendProv: this.JudgeIsCompany.postaddr
                };
                if (self.$store.state.globalTabType == 'add') {
                    data.mg_majorstr = self.$store.state.addbuy.interface?.data?.mg_majorstr || ''
                    data.mg_ismajor = self.$store.state.addbuy.interface?.data?.mg_ismajor || 0
                    data.order_work = self.$store.state.addbuy.interface?.data?.order_work || ''
                } else if (self.$store.state.globalTabType == 'renew') {
                    data.mg_majorstr = self.$store.state.renewbuy.interface?.data?.mg_majorstr || ''
                    data.mg_ismajor = self.$store.state.renewbuy.interface?.data?.mg_ismajor || 0
                    data.order_work = self.$store.state.renewbuy.interface?.data?.order_work || ''
                } else if (self.$store.state.globalTabType == 'new') {
                    data.mg_majorstr = self.$store.state.newbuy.interface?.data?.mg_majorstr || ''
                    data.mg_ismajor = self.$store.state.newbuy.interface?.data?.mg_ismajor || 0
                    data.order_work = self.$store.state.newbuy.interface?.data?.order_work || ''
                }

                if (this.OrderDetails.productId != '27') {
                    this.$axios({
                        url: '/api/Order/CheckExistsOrderSub?pid=' + this.OrderDetails.productId + "&phone=" +
                            this.JudgeIsCompany.Phone,
                        method: "get"
                    }).then(res => {
                        if (res.data.status) {
                            this.$market.orderAlert({
                                content: res.data.message,
                                confirmCall() {
                                    self.$router.push({
                                        path: '/detail/27',
                                        query: {
                                            orderid: res.data.data
                                        }
                                    })
                                    finish()
                                    self.popOverShow(false)
                                }
                            });
                        } else {
                            this.NewSub(data,finish);
                        }
                    });
                } else {
                    this.NewSub(data);
                }
            },
            formatDate (date) {
                let d = new Date(date)
                let year = d.getFullYear()
                let month = d.getMonth() + 1
                let day = d.getDate()
                if (month < 10) {
                    month = '0' + month
                }
                if (day < 10) {
                    day = '0' + day
                }
                return year + '-' + month + '-' + day
            },
            formatAddr (txt) {
                let a = txt.indexOf('【'),b = txt.indexOf('】')
                if (a >= 0 && b >= 0 && txt[0] == '【') {
                    return txt.substring(0,a) + txt.substring(b-a+1,txt.length)
                } else {
                    return txt
                }

            },
            NewSub(data,finish) {
                
                let self = this
                this.$axios({
                    url: '/api/Product/AddAgreement',
                    method: "post",
                    headers: {
                        'Content-type': 'application/json'
                    },
                    data: data
                }).then(code => {
                    
                    // 开发五部 - 李磊(lilei) 16:16:49
                    // 这个判断可以去掉了。
                    // 开发五部 - 李磊(lilei) 16:17:19
                    // 516  517 515  这些判断
                    // 开发五部 - 王雷(wanglei) 16:17:32
                    // 目前没有这些情况了呗
                    // 开发五部 - 李磊(lilei) 16:17:39
                    // 嗯嗯。
                    // 开发五部 - 王雷(wanglei) 16:17:45
                    // 吼，了解了
                    // 开发五部 - 李磊(lilei) 16:17:46
                    // 这个产品都下架了。
                    // 开发五部 - 李磊(lilei) 16:17:57
                    // 应该是历史数据。
                    // if(!code.data.result.status && code.data.result.code == '515') {
                    //     this.$market.orderAlert({
                    //         content: '请先<a id="history_alert_link" class="blue_link">点击提交机构购买申请</a>，通过后才可继续购买',
                    //         hasBtn: false,
                    //         closeBtn: true,
                    //         closeCall: ()=>{
                    //             finish()
                    //         },
                    //         mountHandle: close=>{
                    //             document.getElementById('history_alert_link').addEventListener('click', ()=>{
                    //                 this.$market.historyForm({
                    //                     closeBtn: true,
                    //                     closeCall: ()=>{
                    //                         finish()
                    //                     },
                    //                     confirmCall: (data, closePanel,closeLoading) =>{
                    //                         data.WhAppType = 0 //来源wh9
                    //                         data.plat = 0 //平台pc
                    //                         this.$axios({
                    //                             //下方接口https://wh9.wenhua.com.cn/api/AddApi/AddHistoryDataService暂时修改，避免被程序扫到无效地址
                    //                             url: process.env.NODE_ENV == "development" ? '/api/AddApi//AddHistoryDataService' : 'https://wt9.wenhua.com.cn/api/AddApi/AddHistoryDataService',
                    //                             method: 'post',
                    //                             data
                    //                         }).then(res=>{
                    //                             closeLoading()
                    //                             if (res.data.status) {
                    //                                 closePanel()
                    //                                 this.$market.alert({content: `<p class='icon-sucsuss alert_title1'>提交申请成功！</p><div class='alert_tips1'>请您在1个工作日后到<a href="https://pay.wenhua.com.cn" target="_blank" style="color:blue;text-decoration: underline;">小超市</a>->9C套餐+选配“历史数据API”，按提示付费购买本服务。</div>`})
                    //                             } else {
                    //                                 this.$market.alert({content: `<p class='icon-error alert_title1'>提交失败</p><div class='alert_tips1'>${res.data.message}</div>`})
                    //                             }
                    //                             finish() 
                    //                         })
                    //                     }
                    //                 })
                    //                 close()
                    //             })
                    //         }
                    //     })
                    //     return
                    // } else if (!code.data.result.status && (code.data.result.code == '516' || code.data.result.code == '517')) {
                    //     this.$market.orderAlert({
                    //         content: code.data.result.message
                    //     })
                    //     return finish()
                    // }

                    let dialog = new Promise((resolve,reject)=>{
                        if (!code.data.result.status && code.data.result.code != '668') {
                            this.$market.orderAlert({
                                content: code.data.message,
                                confirmCall() {
                                    self.$refs.scrollBox.scrollTop = 0
                                }
                            });
                            this.$refs['subBtn'].finish()
                            return;
                        } else if (!code.data.result.status && code.data.result.code == '668') {
                            this.$market.agree({
                                content: code.data.result.message,
                                agreeBtn: '继续购买',
                                cancelBtn: '退出购买',
                                agreeCall() {
                                    //调整香港授权数据，境内切成境外
                                    let rejectId = self.$store.state.curTabInstance.checkRejection(code.data.result.zhid)
                                    let subids = self.OrderDetails.subids
                                    self.OrderDetails.subids = subids.replace(rejectId, code.data.result.zhid)
                                    resolve()
                                },
                                degreeCall() {
                                    self.$refs['subBtn'].finish()
                                    self.close()
                                }
                            })
                        } else {
                            resolve()
                        }
                    })

                    dialog.then(_=>{
                        let data;
                        if (self.isCountry) {
                            data = code.data.result.data;
                            data.sdate = self.formatDate(data.sdate)
                            //填坑补丁，此处为字段大小写没法对应上，故意重写到数据上的
                            data.CompanyAddress= data.companyAddress
                            data.CompanyTelnumber= data.companyTelnumber
                            data.CompanyBank= data.companyBank
                            data.CompanyAccount= data.companyAccount
                            data.InvoiceAddr= self.JudgeIsCompany.postaddr + self.JudgeIsCompany.InvoiceAddr
                            data.sendProv = self.JudgeIsCompany.postaddr
                        } else {
                            data = {
                                contactIdCard: code.data.result.data.contactIdCard,
                                contactPassport: code.data.result.data.contactPassport,
                                isCme: self.OrderDetails.isout,
                                userCode: self.OrderDetails.userCode,
                                xzh: self.OrderDetails.xzh,
                                isjg: self.OrderDetails.isjg,
                                ismajor: self.OrderDetails.ismajor,
                                identityType: self.BuySituation,
                                username: self.JudgeIsCompany.UserName,
                                sdate: self.chaneOpenTime,
                                phone: self.JudgeIsCompany.Phone,
                                idCard: self.isCountry ? self.JudgeIsCompany.idCard : (self.JudgeIsCompany.isidcard == 1 ? '' : self.JudgeIsCompany.DetailUserId),
                                faxNumber: self.JudgeIsCompany.FaxNumber,
                                contactname: self.JudgeIsCompany.ContactName,
                                contactIdCard: self.JudgeIsCompany.idCard,
                                // idcard: this.isCompany ? this.JudgeIsCompany.FaxNumber : (this.isout ? this.JudgeIsCompany.DetailUserId : this.JudgeIsCompany.idCard),
                                isidcard: self.isCompany ? 0 : (self.isout ? self.JudgeIsCompany.isidcard :
                                    1),
                                time: "",
                                isYourself: "是",
                                invoicetype: self.Invoicing ? 1 : 0,
                                CompanyAddress: self.JudgeIsCompany.CompanyAddress,
                                CompanyTelnumber: self.JudgeIsCompany.CompanyTelnumber,
                                CompanyBank: self.JudgeIsCompany.CompanyBank,
                                CompanyAccount: self.JudgeIsCompany.CompanyAccount,
                                InvoiceAddr: self.JudgeIsCompany.postaddr + self.JudgeIsCompany.InvoiceAddr,
                                sendProv: self.JudgeIsCompany.postaddr
                            }
                            if (self.isTaiLi) {
                                data.prov = code.data.result.data.prov
                            }
                        }
                        data.userinformation = code.data.userinformation;
                        data.amount = self.OrderDetails.amount;
                        data.payGateID = self.OrderDetails.payGateID;
                        data.dzh = self.OrderDetails.dzh;
                        data.subids = self.OrderDetails.subids;
                        data.productId = self.OrderDetails.productId;
                        data.morderid = self.OrderDetails.morderid;
                        data.isDanAuthorization = self.OrderDetails.isDanAuthorization;
                        data.accountType = code.data.result.data.accountType
                        self.islogout = true;
                        data.IsDzh = code.data.result.data.identityType == '1' ? self.$store.getters['renewbuy/isDzh'] : false
                        data.SeatType = this.initData.islive ? 2 : 1
                        data.isMonth = self.OrderDetails.isMonth;
                        data.IsQuarter = self.OrderDetails.IsQuarter
                        data.isQuarter_sub = false

                        data.country = code.data.result.data.country
                        data.city = code.data.result.data.city
                        data.detailaddr = code.data.result.data.detailaddr
                        
                        if (self.$store.state.globalTabType == 'add') {
                            data.isQuarter_sub = self.$store.state.addbuy.interface?.data?.isQuarterPay_sub || false
                        } else if (self.$store.state.globalTabType == 'renew') {
                            data.isQuarter_sub = self.$store.state.renewbuy.interface?.data?.isQuarterPay_sub || false
                        }
                        return new Promise((resolve,feject)=>{
                            self.$axios({
                                url: '/api/Order/Confirm',
                                method: "post",
                                data: data
                            }).then(res => {
                                let is_reject = false
                                if (res.data.status == false) {
                                    self.$market.orderAlert({
                                        content: res.data.message,
                                        confirmCall() {
                                            self.$refs.scrollBox.scrollTop = 0
                                        }
                                    });
                                    self.$refs['subBtn'].finish()
                                    return;
                                }
                                self.$refs['subBtn'].finish()


                                if (self.isPeiXun) {
                                    data.ishotel = self.bookHotel
                                    data.inday = self.checkDate[0]
                                    data.outday = self.checkDate[1]
                                }
                                data.provinceId = this.listQuery.provinceId
                                data.cityId = this.listQuery.cityId
                                data.regionId = this.listQuery.regionId
                                data.external_city = this.listQuery.external_city
                                self.$store.commit('Order/setSubmitData', data)
                                res.data.price = this.totalPrice
                                self.$store.commit('Order/setUser', res.data)
                                if (self.isWT8 || self.isWT9 || self.isWH7) {
                                    // if (data.identityType == 2) {
                                    //     self.$market.agree({
                                    //         content: '根据监管要求，第一次使用程序化交易软件需向所开户的期货公司报告，期货公司确认审核通过后才可下单。<br><br>*如有多个资金账号需分别向多个期货公司报告',
                                    //         agreeBtn: '去向期货公司报告',
                                    //         cancelBtn: '已报告，跳过',
                                    //         agreeCall() {
                                    //             self.$emit('program-apply')
                                    //         },
                                    //         degreeCall() {
                                    //             self.$emit('pay')
                                    //         }
                                    //     })
                                    // } else {
                                    //     self.$emit('program-apply')
                                    // }
                                    self.$emit('program-apply')
                                    
                                } else {
                                    self.$emit('pay')
                                }
                                resolve()
                            }).catch(error => {
                                self.$refs['subBtn'].finish()
                            });
                        })
                    }).then(_=>{
                        let url,data
                        if (self.$store.state.globalTabType == 'new') {
                            url = self.$store.state.newbuy.interface?.url
                            data = self.$store.state.newbuy.interface?.data
                        } else if (self.$store.state.globalTabType == 'add') {
                            url = self.$store.state.addbuy.interface?.url
                            data = self.$store.state.addbuy.interface?.data
                        }
                        //这里调接口的目的是为了在订单页面不关闭的情况下新增了子产品，重新计算价格，所以根据之前vuex里的记录，重新调接口为了计算一下
                        if (url && data) {
                            data.subids = self.OrderDetails.subids
                            //2021514  新增分笔付款，没传morderid
                            if(self.OrderDetails.productId == '27' && self.OrderDetails.morderid != ""){
                                data.morderid = self.OrderDetails.morderid
                            }
                            self.$axios({
                                url,
                                method: "post",
                                headers: {
                                    'Content-type': 'application/json'
                                },
                                data
                            }).then(({data})=>{
                                self.OrderDetails.contract = data.contract
                                self.OrderDetails.TotalPrice = data.price
                            })
                        }
                    })
                });
            },

            close() {
                //如果是星格官网通过iframe打开支付功能
                if (this.$store.state.inIframe) {
                    window.parent.postMessage('close', 'https://www.starquant.com.cn/');
                    return
                }
                if (this.$store.state.payOk) {
                    this.clearAddBuyValidState()()
                    this.clearRenewBuyValidState()()
                    this.$store.commit('setPayState', false)
                }
                this.JudgeIsCompany.Phone = ''
                this.chaneOpenTime = ''
                this.OrderDetails.wh10Account = ''
                this.OrderDetails.isWh10TryAccount = false
                this.OrderDetails.isWh5TransAccount = false
                this.OrderDetails.wh5Account = ''
                this.OrderDetails.isWh5Autojg = false
                this.OrderDetails.isOnly5C = false
                this.JudgeIsCompany.Phone = ''
                this.popOverShow(false);
                this.orderShow(false);
                this.appOverFlow('auto')
                this.clear()
            },
            clear () {
                this.JudgeIsCompany.postaddr = '省份'
            },
            yearLater(val) {
                function getDaysInNextMonth() {  
                    // 获取今天的日期对象  
                    const today = new Date();  
                    
                    // 获取今天的月份（从0开始，所以实际是上个月）  
                    const currentMonth = today.getMonth();  
                    
                    // 获取今天的年份  
                    const currentYear = today.getFullYear();  
                    
                    // 计算下个月的月份和年份  
                    let nextMonth = currentMonth + 1;  
                    let nextYear = currentYear;  
                    
                    // 如果下个月是12月，则年份需要+1  
                    if (nextMonth === 12) {  
                        nextMonth = 0;  
                        nextYear += 1;  
                    }  
                    
                    // 创建一个新的日期对象，设置为下个月的最后一天（下个月的第一天的日期设为0）  
                    const nextMonthLastDay = new Date(nextYear, nextMonth + 1, 0);  
                    
                    // 获取下个月最后一天是几号（即下个月的天数）  
                    const daysInNextMonth = nextMonthLastDay.getDate();  
                    
                    return daysInNextMonth;  
                }  
                function getNextThreeMonthsDays() {  
                    // 获取今天的日期对象  
                    const today = new Date();  
                    let months = 0;  
                
                    for(let i = 0; i < 3; i++) {  
                        // 获取今天的月份（从0开始）  
                        const currentMonth = today.getMonth();  
                
                        // 获取今天的年份  
                        const currentYear = today.getFullYear();  
                
                        // 计算下个月的年份和月份  
                        let nextYear = currentYear;  
                        let nextMonth = currentMonth + 1;  
                
                        // 如果下个月是12月，则年份需要+1  
                        if (nextMonth === 12) {  
                            nextMonth = 0;  
                            nextYear += 1;  
                        }  
                
                        // 创建一个新的日期对象，设置为下个月的最后一天（设为该月的第一天，然后增加一个月再减去一天）  
                        const nextMonthFirstDay = new Date(nextYear, nextMonth, 1);  
                        nextMonthFirstDay.setMonth(nextMonthFirstDay.getMonth() + 1);  
                        nextMonthFirstDay.setDate(nextMonthFirstDay.getDate() - 1);  
                        
                        // 获取下个月的总天数  
                        const daysInNextMonth = nextMonthFirstDay.getDate();  
                        months += daysInNextMonth  
                
                        // 更新今天的日期，以继续计算下下个月的天数  
                        today.setMonth(today.getMonth() + 1);  
                    }  
                    return months;  
                }  
                let delay_days = 364
                if (this.isMonth) {
                    delay_days = getDaysInNextMonth()
                } else if (this.IsQuarter) {
                    delay_days = getNextThreeMonthsDays()
                }
                if (!this.isMonth && !this.IsQuarter) {
                    if ((new Date(val).getFullYear() + 1) % 4 == 0 && new Date(val).getMonth() >= 2) {
                        delay_days = 365
                    }
                }

                let date = new Date(new Date(val).getTime() + 60 * 60 * 24 * delay_days * 1000)
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let day = date.getDate()
                return year + '-' + month + '-' + day
            },
            yearNow(val) {
                function formatDateToYMD(dateInput) {
                    // 1. 处理输入，转换为标准 Date 对象
                    let date;
                    if (!dateInput) {
                        // 无输入时默认使用当前日期
                        date = new Date();
                    } else if (dateInput instanceof Date) {
                        // 输入为 Date 对象，直接使用
                        date = dateInput;
                    } else if (typeof dateInput === 'number' || /^\d+$/.test(dateInput)) {
                        // 输入为时间戳（数字或数字字符串），转换为 Date
                        date = new Date(Number(dateInput));
                    } else if (typeof dateInput === 'string') {
                        // 输入为日期字符串（如 '2025-12-31'、'2025/12/31'），转换为 Date
                        date = new Date(dateInput);
                    } else {
                        console.error('无效的日期输入类型');
                        return null;
                    }

                    // 2. 验证 Date 对象是否有效（避免 Invalid Date）
                    if (isNaN(date.getTime())) {
                        console.error('输入的日期无效');
                        return null;
                    }

                    // 3. 提取年、月、日（月份从 0 开始，需 +1）
                    const year = date.getFullYear();
                    const month = date.getMonth() + 1; // 0 → 1 月，11 → 12 月
                    const day = date.getDate();

                    // 4. 补零处理（月份/日期 <10 时前面加 0，如 3 → '03'）
                    const paddedMonth = String(month).padStart(2, '0');
                    const paddedDay = String(day).padStart(2, '0');

                    // 5. 拼接为 YYYY-MM-DD 格式
                    return `${year}-${paddedMonth}-${paddedDay}`;
                }
                return formatDateToYMD(val)
            },
            computeFreight() {
                let weight = Number(this.OrderDetails.amount * calendar.weight)
                let price

                for (let i = 0; i < calendar.area.length; i++) {
                    if (this.JudgeIsCompany.postaddr.indexOf(calendar.area[i].prov) >= 0) {
                        price = calendar.area[i]
                        break
                    }
                }
                if (weight > 1) {
                    return (price.express + Math.ceil(weight - 1) * price.next) < 10 ? 10 : (price.express + Math.ceil(
                        weight - 1) * price.next)
                } else {
                    return price.express < 10 ? 10 : price.express
                }
            },
            computeInvFreight() {
                let price

                for (let i = 0; i < invoice.area.length; i++) {
                    if (this.JudgeIsCompany.postaddr.indexOf(invoice.area[i].prov) >= 0) {
                        price = invoice.area[i]
                        break
                    }
                }
                return price.express < 10 ? 10 : price.express
            },
            //纸质合同的银行选则change事件
            bankChange (val) {
                this.paperBank = val
            }
        },
        watch: {
            JudgeIsCompany: {
                handler: function () {
                    var _this = this;
                    if (!_this.$refs.count) return
                    let lent = _this.validateTextLength(this.JudgeIsCompany.UserName);
                    //20210518修改 - 新增，不是中国大陆的，字符串长度为13，大陆为4
                    //20211011修改 - 新增，中文名字超过5个字自己选择个人还是机构
                    if(_this.listQuery.provinceId == "中国大陆" || (_this.listQuery.provinceId != "中国大陆" && new RegExp("[\\u4E00-\\u9FFF]+","g").test(this.JudgeIsCompany.UserName))){ //包含中文就是中国人，不包含中文就是外国人
                        if (lent >= 4) {
                            _this.JudgeIsCompany.longAccountType = true
                            _this.isCompany = _this.JudgeIsCompany.longIfcompany ? false : true
                        } else {
                            _this.JudgeIsCompany.longAccountType = false
                            _this.isCompany = false
                        }
                    } else {
                        if (lent >= 13) {
                            _this.JudgeIsCompany.longAccountType = true
                            _this.isCompany = _this.JudgeIsCompany.longIfcompany ? false : true
                        } else {
                            _this.JudgeIsCompany.longAccountType = false
                            _this.isCompany = false
                        }
                    }
                    if (!_this.isCompany) { //个人
                        _this.JudgeIsCompany.FaxNumber = '';
                        _this.JudgeIsCompany.ContactName = '';
                        if (!this.isTaiLi && !this.hasHistory) {
                            _this.Invoicing = false
                            _this.paperContract = false
                        }
                        if (_this.isCountry) {
                            _this.JudgeIsCompany.DetailUserId = '';
                        } else {
                            _this.JudgeIsCompany.idCard = '';
                        }
                    } else { //机构
                        if( !_this.islmeJN){
                            _this.JudgeIsCompany.DetailUserId = '';
                        }
                        if (_this.isCountry) {
                            _this.JudgeIsCompany.contactpassport = '';
                        } else {
                            _this.JudgeIsCompany.idCard = '';
                        }
                    }
                    if (this.OrderDetails.contract != null && this.OrderDetails.contract != '') {
                        this.firstAdd();
                    }
                },
                deep: true
            },
            chaneOpenTime: {
                handler(val) {
                    this.$nextTick(() => {
                        let type = 0
                        if (this.OrderDetails.isMonth) {
                            type = 2
                        } else if (this.OrderDetails.IsQuarter) {
                            type = 1
                        }
                        close_time_creater(this.$axios, val, type).then(res => {
                            let end_date = res.data.endDate
                            //HTMLCollection是一个array-like对象，不能按原样进行iterable。

                            this.$refs.contract && this.$refs.contract.getElementsByClassName('list')[0] && Array.from(this
                                .$refs.contract.getElementsByClassName('starttime'))
                                .forEach(v => {
                                    //只有新购的时候，可以修改合同表格内的开始结束时间
                                    if (this.BuySituation == 2) {
                                        v.innerHTML = this.yearNow(val)
                                    }
                                })
                            this.$refs.contract && this.$refs.contract.getElementsByClassName('list')[0] && Array.from(this
                                .$refs.contract.getElementsByClassName('list')[0].getElementsByClassName('endtime'))
                                .forEach(v => {
                                    //只有新购的时候，可以修改合同表格内的开始结束时间
                                    if (this.BuySituation == 2) {
                                        v.innerHTML = end_date
                                    }
                                })
                            if (this.initData.productId == 39 || this.initData.productId == 78 || this.initData.productId == 79) {
                                this.$refs.contract && this.$refs.contract.getElementsByClassName('yun_sdate')[0] &&
                                    (this.$refs.contract.getElementsByClassName('yun_sdate')[0].innerHTML = this.yearNow(val))
                                this.$refs.contract && this.$refs.contract.getElementsByClassName('yun_edate')[0] &&
                                    (this.$refs.contract.getElementsByClassName('yun_edate')[0].innerHTML = end_date)
                            }
                            document.getElementById('history_sdate') && (document.getElementById('history_sdate').innerHTML = this.yearNow(val))
                            document.getElementById('history_edate') && (document.getElementById('history_edate').innerHTML = this.yearLater(val))

                        })
                        this.triggerAttachment_4()
                    })
                },
                immediate: true
            },
            islogout: function (islogout) {

                if (this.islogout == true) {

                    this.handleCommand(); //调用退出方法

                }

            },
            "JudgeIsCompany.postaddr" () {
                if (this.isTaiLi) {
                    this.freight = this.computeFreight()
                    this.invoice_freight = this.computeInvFreight()

                }
            },
            "listQuery.cityId"() {
                
            },
            paperContract (val,oldval) {
                if (!oldval && val && !this.hasHistory) {
                    this.$market.alert({content:`<h5 class='notice_title'>根据实际需要，请谨慎选择账号开通日期。</h5>
                                                <p class='notice'>1.请确保在所选开通日前款能到账，否则本次购买无效。</p>
                                                <p class='notice'>2.发票只能在账号开通的当月开具，敬请谅解！</p>
                                                `})
                }
            },
            initData: {
                handler (val) {
                    if (val && val.islmgJn != undefined) {
                        if (val.islmgJn == 1) {
                            this.JudgeIsCompany.isidcard = '2'
                        } else {
                            this.JudgeIsCompany.isidcard = '1'
                        }
                    }
                },
                immediate: true
            }
        },
        mounted () {
        //     console.log(Window.devicePixelRatio)
        //     if (wh.mobileBroswerIdentify()) {
        //         this.$refs.container.style.width = window.screen.width + 'px'
        //     }
        }
    };
</script>

<style scoped>

    .select-sit {
        border: 1px rgb(250, 205, 175) solid;
        border-radius: 1px;
        margin-right: 10px;
        padding: 6px 12px;
        line-height: 14px;
        background-color: rgba(255, 253, 239);
        display: inline-block;
        vertical-align: bottom;
    }

    .orderBuy {
        position: fixed;
        width: 925px;
        right: 0;
        transform: translateX(100%);
        top: 0;
        bottom: 0;
        background: url(../assets/image/bg_03.jpg) repeat;
        overflow: auto;
        box-shadow: -3px 0 5px 0px #888;
        z-index: 1001;
        padding: 33px 0 10px 20px;
        box-sizing: border-box;
        font-size: 14px;
        transition: all 0.5s;
        user-select: none;
    }
    .orderBuy.show {
        transform: translateX(0);
    }


    .close_btn {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 20px;
        top: 10px;
    }

    .close_btn::before {
        content: '';
        width: 25px;
        height: 2px;
        background-color: rgb(53, 59, 63);
        position: absolute;
        top: 10px;
        left: 0;
        transform: rotate(45deg);
    }

    .close_btn::after {
        content: '';
        width: 25px;
        height: 2px;
        background-color: rgb(53, 59, 63);
        position: absolute;
        top: 10px;
        left: 0;
        transform: rotate(-45deg);
    }

    .close_btn:hover::before,
    .close_btn:hover::after {
        background-color: #999;
    }

    /* .Personal_Information, */
    .Purchase_Contract {
        padding: 0 78px 0 0;
    }

    .title {
        line-height: 28px;
        font-size: 14px;
    }

    .form_Msg {
        display: flex;
        flex: auto;
        margin: 15px 0 0 0;
    }

    .form_tit {
        flex: 6;
        text-align: right;
        line-height: 34px;
    }

    .form_input {
        flex: 16;
        margin-left: 18px;
        position: relative;
    }

    .form_input .down_pull {
        position: absolute;
        top: 100%;
        left: 0;
        width: 95%;
        z-index: 50;
        min-height: 100px;
        padding: 0
    }
    .form_input .down_pull .el-icon-loading {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -20px;
        margin-top: -10px;
        font-size: 20px;
    }
    .form_input .down_pull >>> .el-card__body {
        padding: 0;
    }
    .form_input .down_pull ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .form_input .down_pull ul li {
        padding: 10px;
    }
    .form_input .down_pull ul li:hover {
        background-color: #eff4fc;
        
    }
    .form_input .down_pull ul li.active {
        background-color: #eff4fc;
    }
    .form_input .down_pull .more {
        color: #0082da;
        padding: 10px;
        display: block;
    }
    .form_span {
        flex: 9;
        font-size: 12px;
        padding: 4px 47px 0 0;
    }

    .form_input span {
        color: #a62424;
        width: 5%;
        line-height: 26px;
        text-align: center;
        display: inline-block;
    }

    input[type="text"],
    select {
        height: 32px;
        border: 1px solid #d4d4d4;
        width: 95%;
        background-color: #ffffff;
        padding: 0 10px;
        box-sizing: border-box;
    }

    input[type="text"]:disabled {
        border: 1px solid transparent;
        background: transparent;
    }

    select:disabled {
        border: 1px solid transparent;
        background: transparent;
    }

    select {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        background: url('../assets/image/jian1.png') right 8px center no-repeat;
        background-size: 10px;
        background-color: #ffffff;
    }

    #external_city {
        width: 60%;
        margin-left: 5%;
    }

    .filter-item {
        width: 30%;
    }

    .filter-item:nth-of-type(2) {
        margin: 0 2.5%;
    }

    input[type="checkbox"] {
        vertical-align: text-bottom;
        margin-right: 5px;
    }

    hr {
        height: 1px;
        background-color: #e1e1e1;
        border: none;
        margin: 22px 0;
    }

    .submitForm {
        width: 170px;
        height: 34px;
        line-height: 32px;
        text-align: center;
        color: #fceae8;
        background-color: #d40201;
        margin: 40px auto;
        cursor: default;
        display: block;
    }

    #isidcard {
        width: 30%;
        margin-right: 5%;
    }

    #DetailUserId {
        width: 60%;
    }

    .TotalPrice {
        line-height: 48px;
    }

    .TotalPrice span {
        font-weight: 700;
        color: #d70101;
        font-size: 18px;
    }

    .agreeMent {
        height: 42px;
        line-height: 42px;
        margin-top: 14px;
    }

    .date-picker {
        border-radius: 0;
    }

    .date-picker>>>.el-input__inner {
        border-radius: 0;
        border: 1px solid #d4d4d4;
    }

    .tali_table {
        border: 1px solid #cdcdcd;
        min-width: 700px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .tali_table th {
        background-color: #0082da;
        color: #fff;
        text-align: center;
        padding: 10px 5px;
        border: 1px solid #cdcdcd;
    }

    .tali_table td {
        text-align: left;
        padding: 10px 5px;
        border: 1px solid #cdcdcd;
    }

    .taili_detail {
        margin-left: 10px;
    }


    
    /* @media screen and (max-width: 925px) {
        .orderBuy {
            width: 100%;
        }
        .Personal_Information,
        .Purchase_Contract {
            padding: 0 0 0 0;
        }
        .form_span {
            padding-right: 10px;
        }
        .form_tit {
            line-height: normal;
            padding-top: 5px;
        }
    } */
</style>